
      function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStatusDeliveryUpdated = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20.159,
  height: 20.159,
  viewBox: "0 0 20.159 20.159"
}, props), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 229",
  d: "M10.079 0a.657.657 0 0 1 0 1.315 8.765 8.765 0 0 0-8.764 8.62v.144a8.777 8.777 0 0 0 8.779 8.766 8.3 8.3 0 0 0 2.011-.242 8.74 8.74 0 0 0 6.739-8.51.657.657 0 0 1 1.315 0 10.053 10.053 0 0 1-7.746 9.788 9.6 9.6 0 0 1-2.321.279A10.092 10.092 0 0 1 0 10.08v-.167A10.08 10.08 0 0 1 10.079 0zm7.7 3.917a.657.657 0 0 1 .03.9l-.03.032-8.315 8.324a.657.657 0 0 1-.9.03l-.032-.03-2.643-2.649a.657.657 0 0 1 .9-.958l.031.034L9 11.778l7.847-7.86a.657.657 0 0 1 .93 0z",
  style: {
    fill: "var(--theme-primary, #810ea9)"
  }
}));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20.159\" height=\"20.159\" viewBox=\"0 0 20.159 20.159\">\r\n    <path data-name=\"Path 229\" d=\"M10.079 0a.657.657 0 0 1 0 1.315 8.765 8.765 0 0 0-8.764 8.62v.144a8.777 8.777 0 0 0 8.779 8.766 8.3 8.3 0 0 0 2.011-.242 8.74 8.74 0 0 0 6.739-8.51.657.657 0 0 1 1.315 0 10.053 10.053 0 0 1-7.746 9.788 9.6 9.6 0 0 1-2.321.279A10.092 10.092 0 0 1 0 10.08v-.167A10.08 10.08 0 0 1 10.079 0zm7.7 3.917a.657.657 0 0 1 .03.9l-.03.032-8.315 8.324a.657.657 0 0 1-.9.03l-.032-.03-2.643-2.649a.657.657 0 0 1 .9-.958l.031.034L9 11.778l7.847-7.86a.657.657 0 0 1 .93 0z\" style=\"fill:var(--theme-primary, #810ea9)\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/statusDeliveryUpdated.5a02a5fb1c74f8470a80a237d3f2be78.svg"),
        {
          React: SvgStatusDeliveryUpdated,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      